// extracted by mini-css-extract-plugin
module.exports = {"videoContainer":"_02712f2b3b--videoContainer--YYr85","video":"_02712f2b3b--video--Ss8eJ"};